<template>
    <section>
      <div class="title-container">
        <h3 class="title">
          Users
          <div
            class="spinner-border spinner-theme_default"
            role="status"
            v-if="isLoading"
          >
            <span class="sr-only">
              Loading...
            </span>
          </div>
        </h3>
        <div class="title-container__controls">
          <b-button
            class="button"
            variant="success"
            @click="showCreateUserProfileModal = true"
          >
            <span class="material-icons">
              add
            </span>
            Add user profile
          </b-button>
          <b-button
            class="button title-container__controls-item"
            :variant="isShowFilter ? 'secondary' : 'info'"
            @click="toggleShowFilter"
          >
            <span class="material-icons icon-image-preview">
              tune
            </span>
            Filters
          </b-button>
        </div>
      </div>
      <Filters
        v-show="isShowFilter"
        textButtonSubmit="Filter"
        :data="filters"
        withGroups
        :isLoading="isLoading"
        @submit="onFilter"
        ref="filter"
      >
        <template v-slot:skills="slotProps">
            <b-form-group>
              <div class="row m-0">
                <div class="col-5">
                  <label class="form__label">{{slotProps.data.data.label}}</label>
                </div>
              <div class="col-7">
                  <label class="form__label">Select value</label>
              </div>
              </div>
              <div class="d-flex">
                <div class="col-5">
                  <multiselect
                    v-model="skill"
                    :options="skills"
                    track-by="id"
                    label="name"
                    :allow-empty="false"
                    :showLabels="false"
                  />
                </div>
                <div class="col-5">
                  <multiselect
                    v-model="skill_value"
                    :options="skillValueOptions"
                    :allow-empty="false"
                    :showLabels="false"
                  />
                </div>
                <div class="col-2">
                  <b-button
                    class="button btn-icon"
                    variant="success"
                    :disabled="disableFilterButton"
                    @click="addSkillToFilter(slotProps.data.data)"
                  >
                    <span class="material-icons">
                      add
                    </span>
                  </b-button>
                </div>
              </div>
            </b-form-group>
        </template>
      </Filters>
      <data-users
          v-if="$can('read_all-users')"
          :users="users"
          :fieldsUserSkills="fieldsUserSkills"
          @updateUser="getUserAfterUpdate"
      >
      </data-users>

      <ModalCreateUserProfile
          v-model="showCreateUserProfileModal"
          @change="getUserAfterUpdate"
      />
    </section>
</template>

<script>
import DataUsers from './DataUsers'
import ModalCreateUserProfile from '@components/modals/ModalCreateUserProfile'
import Filters from '@components/Filter/Filter'
import moment from 'moment'
import { mapGetters } from 'vuex'

export default {
  name: 'SearchBySkill',

  components: {
    DataUsers,
    Filters,
    ModalCreateUserProfile
  },

  data () {
    return {
      showCreateUserProfileModal: false,
      filterShow: false,
      users: [],
      isLoading: false,
      isDateChangedFirst: true,
      searchSkills: [],
      skills: [],
      skill: null,
      skill_value: '',
      skillValueOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      least_one: false,
      fieldsUserSkills: [],
      date: {
        can_be_booked_from: null,
        can_be_booked_to: null
      },
      disabledDates: {
        to: null
      },
      filters: {
        groups: {
          availability: {
            name: 'Availability and skills',
            fields: {
              'date_from': {
                type: 'datepicker',
                name: 'can_be_booked_from',
                label: 'Available from',
                disabledDates: { to: new Date(Date.now() - 8640000) },
                format: 'dd/MM/yyyy',
                validation: [
                  { name: 'required' }
                ],
                value: null,
                class: 'col-md-2',
                group: 'availability'
              },
              'date_to': {
                type: 'datepicker',
                name: 'can_be_booked_to',
                label: 'Available to',
                disabledDates: { to: new Date(Date.now() - 8640000) },
                format: 'dd/MM/yyyy',
                validation: [
                  { name: 'required' }
                ],
                value: null,
                class: 'col-md-2',
                group: 'availability'
              },
              'skills': {
                type: 'slot',
                slotName: 'skills',
                name: 'searchSkills',
                label: 'Select skill',
                selectLabel: 'alias',
                valueField: 'id',
                value: [],
                class: 'col-md-5',
                group: 'availability'
              },
              'least_one': {
                type: 'checkbox',
                name: 'least_one',
                label: 'At least one skill',
                value: null,
                class: 'col-md-2',
                group: 'availability'
              }
            }
          },
          users: {
            name: 'Users',
            fields: {
              'users': {
                type: 'multiselect',
                name: 'users',
                label: 'Select user',
                class: 'col-md-2',
                valueField: 'jira_user_name',
                selectLabel: 'label',
                options: [],
                value: [],
                group: 'users'
              },
              'user_status': {
                type: 'select',
                name: 'user_status',
                label: 'Select status',
                class: 'col-md-2',
                valueField: 'status',
                selectLabel: 'label',
                options: [{ status: 'all', label: 'All' }, { status: 'active', label: 'Active' }, { status: 'inactive', label: 'Inactive' }],
                value: { status: 'active', label: 'Active' },
                group: 'users'
              },
              'users_roles': {
                type: 'multiselect',
                name: 'users_roles',
                label: 'Select role',
                class: 'col-md-2',
                valueField: 'name',
                selectLabel: 'display_name',
                options: [],
                value: [],
                group: 'users'
              },
              'users_type': {
                type: 'select',
                name: 'user_type',
                label: 'User type',
                class: 'col-md-2',
                valueField: 'type',
                selectLabel: 'label',
                options: [{ type: 'all', label: 'All' }, { type: 'user', label: 'User' }, { type: 'user-profile', label: 'User profile' }],
                value: [],
                group: 'users'
              }
            }
          }
        }
      },
      isShowFilter: true
    }
  },
  computed: {
    ...mapGetters({
      getUserRoles: 'getRoles'
    }),
    disableFilterButton () {
      return !(this.skill && this.skill_value)
    },
    fromDateUTC () {
      if (this.date.can_be_booked_from) {
        return moment.utc(this.date.can_be_booked_from, 'YYYY-MM-DD')
      }
      return Date.now()
    },
    filterFields () {
      const fields = {}
      for (let groupKey in this.filters.groups) {
        let groupFields = this.filters.groups[groupKey].fields
        for (let fieldName in groupFields) {
          fields[fieldName] = groupFields[fieldName]
        }
      }
      return fields
    }
  },
  created () {
    this._toggleDataPageLoading(async () => {
      await this.fetchAllData()
    })
  },
  methods: {
    async fetchUserRoles () {
      return this.$api.roles.getRoles()
    },
    fetchAllData () {
      return Promise.all([
        this.getUsers(),
        this.fetchUserRoles(),
        this.getSkills()
      ]).then(() => {
        this.setAllOptionsFilter()
      }).then(() => {
        const dateForRequest = this.prepareDataForGetUsers(this.filterFields)
        this.searchBySkill(dateForRequest)
      })
    },
    setAllOptionsFilter () {
      this.filters.groups.users.fields.users.options = this.users
      this.filters.groups.users.fields.users_roles.options = [
        {
          display_name: 'All',
          name: 'all'
        },
        ...this.getUserRoles
      ]
    },
    getUserAfterUpdate () {
      const filterContainer = this.$refs.filter
      filterContainer.submit()
    },
    prepareDataForGetUsers (fields) {
      let data = {}

      for (let key in fields) {
        const name = fields[key]['name']
        let value = fields[key]['value']

        if (Object.prototype.toString.call(value) === '[object Date]') {
          value = this._toLocalTime(value)
        }

        if (name === 'user_status' && value) {
          value = value.status
        }
        if (name === 'user_type' && value) {
          value = value.type
        }
        if (name === 'users' && value) {
          value = value.map(el => el.jira_user_name)
        }
        if (name === 'users_roles' && value) {
          value = value.map(el => el.name)
        }

        data[name] = value
      }

      return data
    },
    toggleShowFilter () {
      this.isShowFilter = !this.isShowFilter
    },
    clearSkill () {
      this.skill = null
      this.skill_value = ''
    },
    addSkillToFilter (formSkillsValue) {
      // Change value into FormGenerator and update Filter

      const key = 'skills'
      let skill = {
        id: this.skill.id,
        name: this.skill.name,
        value: this.skill_value,
        alias: `${this.skill.name} ${this.skill_value}`
      }

      let formGeneratorContainer = this.$refs.filter.$refs.formGenerator
      let skillValue = formGeneratorContainer.fields.groups.availability.fields[key].value

      const isSimiliarSkill = skillValue.some(item => {
        return item.id === skill.id
      })

      if (isSimiliarSkill) {
        this.$snotify.error('Skill can not be duplicated',
          'Error', this.$store.state.snotify)
        return this.clearSkill()
      }

      formGeneratorContainer.fields.groups.availability.fields[key].value.push(skill)
      formGeneratorContainer.updateItem(key, formSkillsValue)
      this.clearSkill()
    },
    onFilter (data) {
      const dateForRequest = this.prepareDataForGetUsers(data)
      this.searchBySkill(dateForRequest)
    },
    toggleFilter () {
      this.filterShow = !this.filterShow
    },
    addItem () {
      if (this.searchSkills.length > 0) {
        var skill = 'undefined'
        this.searchSkills.find((searchSkill) => {
          if (searchSkill.id === this.skill.id) {
            skill = this.searchSkills.indexOf(searchSkill)
          }
        })
        if (skill !== 'undefined') {
          this.searchSkills.splice(skill, 1)
        }
      }
      this.searchSkills.push({
        id: this.skill.id,
        name: this.skill.name,
        value: this.skill_value
      })
      this.skill = null
      this.skill_value = null
    },

    isDateChanged (e) {
      this.isDateChangedFirst = false
      this.disabledDates.to = e
      this.date.can_be_booked_from = e
      this.date.can_be_booked_to = e
    },

    isDateChangedForSecond (e) {
      this.date.can_be_booked_to = e
    },

    onReset (e) {
      e.preventDefault()
      this.searchSkills = []
      this.date.can_be_booked_from = null
      this.date.can_be_booked_to = null
      this.getUsers()
      this.$nextTick(() => {
        this.show = true
      })
    },
    searchBySkill (formData) {
      this.isLoading = true
      // can_be_booked_from: "2020-10-29"
      // can_be_booked_to: "2020-10-29"
      // least_one: false
      // searchSkills: []
      // let formData = {
      //   searchSkills: this.searchSkills,
      //   least_one: this.least_one,
      //   can_be_booked_from: this.date.can_be_booked_from ? moment(this.date.can_be_booked_from).format('YYYY-MM-DD') : null,
      //   can_be_booked_to: this.date.can_be_booked_to ? moment(this.date.can_be_booked_to).format('YYYY-MM-DD') : null
      // }
      // if (!this.date.can_be_booked_from) {
      //   delete formData.can_be_booked_from
      //   delete formData.can_be_booked_to
      // }
      this.axios.post(
        `/api/skill/search`,
        {
          ...formData
        },
        {
          headers: {
            Authorization: 'Bearer' + this.$store.getters.getAccessToken
          }
        }).then(response => {
        if (response.status === 200) {
          this.fieldsUserSkills = []
          for (let i = 0; i < this.searchSkills.length; i++) {
            this.fieldsUserSkills.push({
              id: this.searchSkills[i].id,
              label: this.searchSkills[i].name
            })
          }
          this.users = response.data
        }
      }).catch(err => {
        console.log(err)
        let errors = Object.values(err.response.data.errors)
        for (let i = 0; i < errors.length; i++) {
          this.$snotify.error(errors[i][0], 'Error', this.$store.state.snotify)
        }
      }).finally(() => {
        this.isLoading = false
      })
    },
    getSkills () {
      this.axios({
        method: 'get',
        url: '/api/skills',
        headers: {
          Authorization: 'Bearer' + this.$store.getters.getAccessToken
        }
      }).then(response => {
        this.skills = response.data
      }).catch(err => {
        console.log(err)
        var errors = Object.values(err.response.data.errors)
        for (var i = 0; i < errors.length; i++) {
          this.$snotify.error(errors[i][0], 'Error', this.$store.state.snotify)
        }
      })
    },
    getUsers () {
      this.isLoading = true
      return this.axios({
        method: 'post',
        url: '/api/users-with-trashed',
        headers: {
          Authorization: 'Bearer' + this.$store.getters.getAccessToken
        }
      }).then(response => {
        this.users = response.data
        this.fieldsUserSkills = []
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        this.isLoading = false
      })
    }
  }
}
</script>
<style lang='scss' scoped>
.spinner-border{
  position: relative;
  top: 8px;
  margin-left: 10px;
}
.skills-select {
  .vs__dropdown-toggle {
    padding: 5px !important;
  }
}
.selected-skill {
  label{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>

<style scoped>
.title-container__controls {
  gap: 10px;
}
</style>
